import React from 'react';
import { getdata, deletedata } from '../../util/global';

interface props {
  messagedata: any[];
  subscriptiondata: any[];
  userdata: any[];
}

// AdminMessageLogTable: display-only grid of message logs with subscription and user details
const AdminMessageLogTable: React.FC<props> = ({ messagedata, subscriptiondata, userdata }) => {
  const handleaction = async (item: any, action: string) => {
    if (action === 'resend') {
      await getdata({ messagequeueid: item._id }, '/resendmessage');
    }
    if (action === 'delete') {
      if (window.confirm('Are you sure you want to delete this message?')) {
        await deletedata({ filter: { _id: item._id, datatype: 'messagequeuedata' } }, () => {
          window.location.reload();
        });
      }
    }
  };

  const rows = messagedata.map((item, i) => {
    const subscription = subscriptiondata?.find((s: any) => s._id === item._subscriptionid);
    const user = userdata?.find((u: any) => u._id === item._userid);

    return (
      <tr key={item._id || i}>
        <td style={{ width: '60px' }}>
          <select
            className="action-select"
            value=""
            onChange={(e) => handleaction(item, e.target.value)}
          >
            <option value="" disabled>{i + 1}</option>
            <option value="resend">resend</option>
            <option value="delete">Delete</option>
          </select>
        </td>
        <td>{item.updatetimestamp ? item.updatetimestamp.split('T')[0] : '-'}</td>
        <td>{item.messagetype || '-'}</td>
        <td>{item.text || '-'}</td>
        <td>{item.channel || '-'}</td>
        <td>{item?.phone || '-'}</td>
        <td>{item?.email || user?.email || '-'}</td>
        <td>{subscription?._id}</td>
        <td><span className={`status-badge ${item.status}`}>{item.status || '-'}</span></td>
      </tr>
    );
  });

  return (
    <table className="grid">
      <thead>
        <tr>
          <th>action</th>
          <th>date</th>
          <th>type</th>
          <th>message</th>
          <th>channel</th>
          <th>phone</th>
          <th>email</th>
          <th>subscriptionid</th>
          <th>status</th>
        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? rows : (
          <tr>
            <td colSpan={10} style={{ textAlign: 'center', padding: '16px' }}>No messages found</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default AdminMessageLogTable;
